export const GET_MAP = 'GET_MAP';
export const GET_MAP_SUCCESS = 'GET_MAP_SUCCESS';
export const GET_MAP_ERROR = 'GET_MAP_ERROR';
